import React from "react";
import { Routes, Route, Navigate } from "react-router-dom";

import ScriptsDashboard from "./ScriptsDashboard";
import Testformpage from "../Testformpage/Testformpage";
import Testformtextbookpage from "../Testformtextbookpage/Testformtextbookpage";
import Testformstorypage from "../Testformstorypage/Testformstorypage";
import Testformimagepage from "../Testformimagepage/Testformimagepage";
import PasageWordMapping from "../PassageWordMapping/PassageWordMapping";
import Downloadreport from "../Downloadreport/Downloadreport";
import Testformdeletepage from "../Testformdeletepage/Testformdeletepage";
import Testformdeleteimage from "../Testformdeleteimage/Testformdeleteimage";
import Testuseruploadform from "../TestUserBulk/TestUserBulk";
import UploadWordMeaning from "../UploadWordMeaning/UploadWordMeaning";
import UploadUserSubscriptions from "../UploadUserSubscription/UploadUserSubscription";
import GenerateTimedTranscript from "../PassageTimedTranscript/PassageTimedTranscript";
import UploadPassageExplanationUpdate from "../UploadPassageExplanation/UploadPassageExplanation";

export default function ScriptsRoutes() {
  return (
    <Routes>
      {/* /scripts => Dashboard */}
      <Route index element={<ScriptsDashboard />} />

      {/* Sub-pages */}
      <Route path="upload_bulk_word_audios" element={<Testformpage />} />
      <Route path="upload_bulk_textbook_passages_and_audios" element={<Testformtextbookpage />} />
      <Route path="upload_bulk_story_passages_and_audios" element={<Testformstorypage />} />
      <Route path="upload_bulk_image_passages_and_audios" element={<Testformimagepage />} />
      <Route path="passage_word_mapping" element={<PasageWordMapping />} />
      <Route path="downloadreport" element={<Downloadreport />} />
      <Route path="deleteform" element={<Testformdeletepage />} />
      <Route path="deleteimage" element={<Testformdeleteimage />} />
      <Route path="bulkuser" element={<Testuseruploadform />} />
      <Route path="upload_meaning" element={<UploadWordMeaning />} />
      <Route path="upload_user_subscription" element={<UploadUserSubscriptions />} />
      <Route path="passage_timed_transcript" element={<GenerateTimedTranscript />} />
      <Route path="upload_passage_explanation" element={<UploadPassageExplanationUpdate />} />

      {/* Fallback */}
      <Route path="*" element={<Navigate to="/scripts" replace />} />
    </Routes>
  );
}

